import axiosInstance from "@/utils/AxiosInstance";
import {RequestCatalogPage} from "@/services/catalogs/entities/RequestCatalogPage";

let BASE_API = '';

const getCatalogPage = async (body: RequestCatalogPage, catalogType: string): Promise<any> => {
    BASE_API = determineCatalogType(catalogType);
    return await axiosInstance.post(`${BASE_API}/page`, body);
}

const createItem = async (body: any, catalogType: string): Promise<any> => {
    BASE_API = determineCatalogType(catalogType);
    return await axiosInstance.post(`${BASE_API}/`, body);
}

const editItem = async (body: any, catalogType: string): Promise<any> => {
    BASE_API = determineCatalogType(catalogType);
    return await axiosInstance.put(`${BASE_API}/`, body);
}

const getCatalogsList = async (): Promise<any> => {
    return await axiosInstance.get(`/clients/catalogs`);
}

const determineCatalogType = (catalogType: string) => {
    switch (catalogType) {
        case 'bebidas':
            return 'beverages';
        case 'medicamentos':
            return 'medications';
        case 'padecimientos':
            return 'ailments';
        case 'dietas':
            return 'diets';
        default:
            throw new Error('Invalid catalog type');
    }
}

export default {
    getCatalogPage,
    createItem,
    editItem,
    getCatalogsList,
}